<script setup lang="ts">
  import SettingsPage from '@/components/app/settings/SettingsPage.vue'
  import CheckboxField from '@/components/admin/form/CheckboxField.vue'
  import SelectField from '@/components/admin/form/SelectField.vue'
  import InputField from '@/components/admin/form/InputField.vue'
  import { useTranslation } from '@/composables/useTranslation'
  import { computed, onMounted, ref, watch } from 'vue'
  import { ComputerDesktopIcon } from '@heroicons/vue/24/outline'
  import { useUserStore } from '@/shared/stores/userStore'
  import type { CustomerUser } from '@/types/generated'
  import { OrganisationsService, RaMicroExportIntegrationTypeEnum } from '@/types/generated'
  import * as Sentry from '@sentry/vue'

  const isLoading = ref(false)
  const { fetchUser } = useUserStore()
  const user = computed<CustomerUser>(() => useUserStore().user)
</script>

<template>
  <SettingsPage v-if="user">
    <div class="space-y-8">
      <p class="mb-3 leading-relaxed text-gray-700">
        Diese Integration wird für Sie von unserem Support Team bereitgestellt und individuell
        konfiguriert.
      </p>
      <p class="leading-relaxed text-gray-700">
        Bitte kontaktieren Sie uns unter
        <a
          href="mailto:support@jupus.de"
          class="font-medium text-purple-600 underline decoration-1 underline-offset-2 transition-colors duration-200
            hover:text-purple-800 hover:decoration-2"
        >
          support@jupus.de
        </a>
      </p>
    </div>
  </SettingsPage>
</template>

<style scoped>
  /* Add any scoped styles here if needed */
</style>
